module.exports = __webpack_public_path__ + "static/fipcballmouse3-cb91679c327588803077b82afc1c09e9.jpeg";